import React from 'react';
import { useHistory } from 'react-router-dom';

import MessagingService from 'services/MessagingService/MessagingService';
import {
  LOGIN_SUCCESS,
  GET_USER_INFO_RESPONSE,
} from 'services/MessagingService/EventNames';
import routeDefinitions from 'enum/routeDefinitions';


function WeakPasswordControlRoom() {
  const history = useHistory();

  const handleLoginSuccess = React.useCallback(
    (user) => {
      if (user.passwordResetToken) {
        history.push(routeDefinitions.weakPasswordReset);
      }
    },
    [history]
  );

  React.useEffect(() => {
    const messagingService = MessagingService();

    messagingService.on(LOGIN_SUCCESS, handleLoginSuccess);
    messagingService.on(GET_USER_INFO_RESPONSE, handleLoginSuccess);

    return () => {
      messagingService.off(LOGIN_SUCCESS, handleLoginSuccess);
      messagingService.off(GET_USER_INFO_RESPONSE, handleLoginSuccess);
    };
  }, [handleLoginSuccess]);

  return null;
}

export default WeakPasswordControlRoom;
